import styled from "styled-components";
import { useHistory } from "react-router-dom";

const Wrapper = styled.button`
  // margin-bottom: 1.2rem;
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

const GoBack = ({ customRoute }) => {
  const router = useHistory();

  return (
    <Wrapper
      className="flexRow alignCenter"
      onClick={() => {
        if (customRoute) {
          router.push(customRoute);
          return;
        }
        
        router.goBack();
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 16L3 12M3 12L7 8M3 12H21"
          stroke="#149DFF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Wrapper>
  );
};

export default GoBack;
